import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { CustomAvatar } from '@app/components/custom-avatar';
import { TableCellCustom } from '@app/components/table';
import { IAddCandidateSchema } from '../types';
import { RowActions } from './row-actions';
import { StatusTag, TruncatedTypography } from '@app/components';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { CandidateStatus } from '@app/constants';

interface Props {
  row: IAddCandidateSchema;
  selected: boolean;
  onSelectRow: VoidFunction;
}

const CandidateRow = (props: Props) => {
  const { row } = props;

  const navigate = useNavigate();
  const handleDetails = () => {
    navigate(`${PATH_DASHBOARD.candidateDetail}/${row.firstName}`, { state: { id: row.id } });
  };

  const statusMapping: Record<string, CandidateStatus> = {
    InterviewScheduled: CandidateStatus.InterviewScheduled,
    Rejected: CandidateStatus.Rejected,
    Saved: CandidateStatus.Saved,
    Shortlisted: CandidateStatus.Shortlisted,
  };
  const statusValue = statusMapping[row.status] || CandidateStatus.Shortlisted;

  return (
    <>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <Stack style={{ flexDirection: 'row', alignItems: 'center', gap: '9px', width: '140px' }}>
          <CustomAvatar
            name={`${row?.firstName} ${row?.lastName}`}
            color="info"
            src={row?.profileImage}
          />
          <TruncatedTypography text={`${row?.firstName} ${row?.lastName}`} />
        </Stack>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <Stack sx={{ alignItems: 'center' }}>
          <Typography variant="body2">{row?.email}</Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }}>
        <Typography variant="body2" width={'60px'}>
          {row?.phone ? row.phone : 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} align="center" style={{ cursor: 'pointer' }}>
        <Typography variant="body2" width={150}>
          {row?.source === 'Other'
            ? row?.other ?? 'NA'
            : row?.source === 'Reference'
            ? `Reference By ${row?.referenceBy ?? 'NA'}`
            : row?.source ?? 'NA'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom
        width={50}
        onClick={handleDetails}
        align="center"
        style={{ cursor: 'pointer' }}
      >
        <StatusTag status={CandidateStatus[statusValue]} />
      </TableCellCustom>
      <TableCellCustom flex onClick={handleDetails} style={{ cursor: 'pointer' }} align="center">
        <TruncatedTypography width={120} text={row?.reason?.trim() || 'NA'} />
      </TableCellCustom>
      <TableCellCustom align="right" width={50}>
        <RowActions row={row} />
      </TableCellCustom>
    </>
  );
};

export { CandidateRow };
